exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.result-percent[data-v-38bcade8] {\r\n  padding-top: 12px;\r\n  padding-bottom: 6px;\n}\n.v-card__text[data-v-38bcade8] {\r\n  line-height: auto;\n}\n.text-center[data-v-38bcade8] {\r\n  text-align: center;\n}\n.correct[data-v-38bcade8] {\r\n  border-style: dotted;\r\n  color: green;\r\n  border-color: green;\r\n  padding: 5px;\n}\n.statement[data-v-38bcade8] {\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\n}\r\n", ""]);

// exports
